import { WatchQueryFetchPolicy } from '@apollo/client';
import { useArticleEditorQuery } from 'lib-knowledge-management-common/graphql';

type UseArticleFetchReturnValue = ReturnType<typeof useArticleEditorQuery>;

function useArticleEditorFetch({
  articleId,
  fetchPolicy = 'cache-and-network',
}: {
  articleId: string;
  fetchPolicy?: WatchQueryFetchPolicy;
}): UseArticleFetchReturnValue {
  return useArticleEditorQuery({
    variables: {
      id: articleId,
    },
    fetchPolicy,
  });
}

export default useArticleEditorFetch;
